import { render } from "./accounts2.vue?vue&type=template&id=3cc343a0"
import script from "./accounts2.vue?vue&type=script&lang=js"
export * from "./accounts2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__